export const AMOUNT_OF_CARDS_TO_SHOW = 3;
